








import { Component, Prop, Mixins } from "vue-property-decorator";
import { IFormatObjectEditable } from "../../../../../domain/editableFormat";
import { IDrawableQuestionnaireObjectEditable } from "../../../../../domain/editableFormat/objectEditors";
import { instanceOfIRectangleCoordinateEditable, instanceOfIQuestionnairePropertyEditable } from "../../../../../domain/editableFormat/properties";
import { QuestionnaireGuidTree } from "../../../../../domain/questionnaire";

@Component
export default class QuestionnaireRelationIndiator extends Mixins() {
  @Prop()
  objects: IFormatObjectEditable[];

  @Prop()
  gap: number;

  @Prop({ default: () => [] as QuestionnaireGuidTree<IFormatObjectEditable>[] })
  treeItems: QuestionnaireGuidTree<IFormatObjectEditable>[];

  get items(): IDrawableQuestionnaireObjectEditable[] {
    return this.objects
      .filter(o => instanceOfIQuestionnairePropertyEditable(o) && instanceOfIRectangleCoordinateEditable(o))
      .map(o => o as IDrawableQuestionnaireObjectEditable);
  }

  get dicitonary(): { [ key: string ]: { object: IDrawableQuestionnaireObjectEditable, top: number, bottom: number } } {
    let top = 0;
    let bottom = 0;
    return this.items.reduce<{ [ key: string ]: { object: IDrawableQuestionnaireObjectEditable, top: number, bottom: number } }>((r, c) => {
      top = bottom + this.gap;
      bottom = top + c.size().getValue().height;
      r[c.questionnaire().getValue()._guid] = { object: c, top, bottom };
      return r;
    }, {});
  }

  get groups(): IDrawableQuestionnaireObjectEditable[] {
    return this.items
      .filter(i => 0 < i.questionnaire().getValue()._childGuids.length);
  }

  toGroupClass(source: IDrawableQuestionnaireObjectEditable) {
    const treeItem = this.treeItems.find(v => v.source === source);
    const selected = treeItem ? (treeItem.source.isSelected() || treeItem.children.some(c => c.source.isSelected())) : source.isSelected();
    return [
      "group",
      selected ? "selected" : undefined,
    ];
  }

  toGroupGeometryStyle(source: IDrawableQuestionnaireObjectEditable) {
    const treeItem = this.treeItems.find(v => v.source === source);
    const family = this.toFamily(source);
    const rectangle = {
      top: Math.min(...family.map(i => this.dicitonary[i.questionnaire().getValue()._guid].top)),
      bottom: Math.max(...family.map(i => this.dicitonary[i.questionnaire().getValue()._guid].bottom)),
      right: 58 + ((treeItem ? treeItem.level : 0) * 10),
    };
    return {
      top: (rectangle.top - 2) + "px",
      height: (rectangle.bottom - rectangle.top + 4) + "px",
      right: rectangle.right + "px",
    };
  }

  toFamily(source: IDrawableQuestionnaireObjectEditable): IDrawableQuestionnaireObjectEditable[] {
    return source
      ? [
        source,
        ...this.toDescendants(source),
      ]
      : [];
  }

  toDescendants(source: IDrawableQuestionnaireObjectEditable): IDrawableQuestionnaireObjectEditable[] {
    // flatが使えないので代替実装でflatten.
    return [].concat(...source.questionnaire().getValue()._childGuids.map(i => this.dicitonary[i] ? this.toFamily(this.dicitonary[i].object) : null)).filter(i => !!i);
  }
}
